import HTTP from "@/utils/http"
const http = new HTTP()

/**
 * @class
 */
export default class Recorder {
  /**
   * @constructor
   * @param {Object} options {
   *  mode:测评模式,
   *  text:测评文本,
   *  audioFileName:音频文件命名
   * }
   */
  constructor(options) {
    this.MODE_TYPE = {
      paragraph: 2, // 段落
      freedom: 3, // 自由说
    }
    this.STATUS_TYPE = {
      UNINITIALIZED: "uninitialized", // 待初始化
      INITIALIZED: "initialized", // 待开始
      RECORDING: "recording", // 正在录音测评
      STOP: "stop", // 停止录音测评
      WAITRESULT: "waitresult", // 等待测评结果
      END: "end", // 测评结束
    }
    this.mode = this.MODE_TYPE[options.mode]
    this.text = options.text
    this.options = options
    this.recorderHandler = null
    this.status = this.STATUS_TYPE.UNINITIALIZED
    this.words = options.text ? options.text.match(/[a-zA-Z]+/gi) : []
  }

  /**
   * @description 获取权限
   */
  static permission() {
    navigator.getUserMedia =
      navigator.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia

    return new Promise((resolve, reject) => {
      if (navigator.getUserMedia) {
        navigator.getUserMedia(
          { audio: true },
          function (stream) {
            stream.getTracks().forEach((track) => track.stop())
            resolve(true)
          },
          function () {
            reject("麦克风授权失败")
          }
        )
      } else if (navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ audio: true })
          .then((stream) => {
            stream.getTracks().forEach((track) => track.stop())
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      }
    })
  }

  /**
   * 初始化
   */
  init() {
    // 测评文本不能为空
    if (!this.options.text) {
      this._error("测评内容不能为空")
      return
    }

    // 段落模式不能超过120个单词
    if (this.mode === this.MODE_TYPE.paragraph && this.words.length > 120) {
      this._error("段落模式不能超过120个单词")
      return
    }

    // 腾讯语音测评参数：https://cloud.tencent.com/document/product/884/32821
    this.recorderHandler = new window.TencentSOE({
      EvalMode: this.mode,
      ScoreCoeff: 3.5, // 严苛度 1-4
      getAuthorization: (callback) => {
        http
          .get({
            url: "/imgup/audio/tencent/init",
            headers: {
              app: process.env.VUE_APP_TYPE,
            },
          })
          .then((res) => {
            callback({
              Token: res.data.Credentials.Token,
              TmpSecretId: res.data.Credentials.TmpSecretId,
              TmpSecretKey: res.data.Credentials.TmpSecretKey,
              ExpiredTime: res.data.ExpiredTime,
            })
          })
          .catch((err) => {
            this._error(err.msg || err.message)
          })
      },
      // 初始化成功
      success: () => {
        setTimeout(() => {
          this.oninit ? this.oninit() : ""
          this.status = this.STATUS_TYPE.INITIALIZED
        }, 1000)
      },
      //初始化失败
      error: (err) => {
        console.log(err)
        this._error(err.msg || err.message)
      },
    })
  }

  /**
   * 开始测评
   */
  start() {
    // console.log(this.recorderHandler.audioContext.state)
    // if (this.recorderHandler.audioContext.state === 'suspended') {
    //   this.recorderHandler.audioContext.resume()
    // }
    const user = JSON.parse(localStorage.getItem("USER"))
    try {
      this.recorderHandler.start({
        RefText: this.text,
        error: (err) => {
          window.__bl && window.__bl.api('TencentSOE-start', false, Date.now(), 'ERROR', JSON.stringify(err))
          console.error("TencentSOE Recorder Error", JSON.stringify(err))
          http.get({
            url: 'https://log.dayuan1997.com/collect',
            params: {
              sessionId: this.recorderHandler.SessionId,
              eleIds: this.options.audioFileName,
              userId: user && user.userId,
            }
          })
          this._error(err.message || err.msg)
        },
        complete: () => {
          console.log("录音超过1分钟未停止触发此回调")
          this.status = this.recorderHandler.STATUS_TYPE.STOP
        },
        success: (res) => {
          if (this.status !== this.STATUS_TYPE.RECORDING) {
            http.get({
              url: 'https://log.dayuan1997.com/collect',
              params: {
                sessionId: this.recorderHandler.SessionId,
                eleIds: this.options.audioFileName,
                requestId: res.RequestId,
                userId: user && user.userId,
              }
            })
            console.log("SessionId:", this.recorderHandler.SessionId, this.options.audioFileName)
            // 绑定事件前，录音可能已经启动，这时候应该减去还未真正开始录音的时间
            const realStartTimeDone = this.recorderHandler.audioContext
              .currentTime
              ? Math.ceil(this.recorderHandler.audioContext.currentTime)
              : 0

            // 实时当前采样点的最高频率
            this.recorderHandler.recorder.processor.addEventListener(
              "audioprocess",
              (e) => {
                let buffer = e.inputBuffer.getChannelData(0)
                this.onprocess
                  ? this.onprocess({
                    wave: Math.max.apply(Math, buffer) * 100,
                    duration:
                      this.recorderHandler.audioContext.currentTime -
                      realStartTimeDone,
                  })
                  : null
              }
            )
          }
          this.status = this.STATUS_TYPE.RECORDING
        },
      })
    } catch (error) {
      this._error(`开始失败`)
      console.log(error)
    }
  }

  /**
   * 停止测评
   */
  stop() {
    console.log("recorder:stop")
    this.status = this.STATUS_TYPE.STOP
    this.recorderHandler.stop({
      success: (res) => {
        // 腾讯返回结果参考：https://cloud.tencent.com/document/api/884/19320#PhoneInfo

        const resVal = {
          pronAccuracy: res.PronAccuracy < 0 ? 0 : res.PronAccuracy,
          pronCompletion:
            (res.PronCompletion < 0 ? 0 : res.PronCompletion) * 100,
          pronFluency: (res.PronFluency < 0 ? 0 : res.PronFluency) * 100,
          suggestedScore: res.SuggestedScore,
        }

        // 命中单词
        resVal.hitWords = this._wordComplete(res.Words)

        // 自由说模式计算完整度 ,TODO:3需要枚举化
        if (this.mode === 3) {
          resVal.suggestedScore =
            (resVal.hitWords.length / this.words.length) * 100
          resVal.pronCompletion =
            (resVal.hitWords.length / this.words.length) * 100
        }

        // 上传文件
        this.status = this.STATUS_TYPE.WAITRESULT
        this._upload(res.blob, this.options.audioFileName)
          .then((fileRes) => {
            this.recorderHandler.recorder.processor.disconnect()
            this.recorderHandler.audioContext.close()
            this.status = this.STATUS_TYPE.END
            this.onstop
              ? this.onstop({
                ...resVal,
                audioUrl: fileRes,
              })
              : null
          })
          .catch((err) => {
            this.recorderHandler.recorder.processor.disconnect()
            this.recorderHandler.audioContext.close()
            console.log(err)
          })
      },
      error: (err) => {
        console.log(err)
        this.status = this.STATUS_TYPE.END
        this._error("录音停止失败，请重新录音")
      },
    })
  }

  _error(msg) {
    console.error(msg)
    this.onerror ? this.onerror(msg) : null
  }

  // 计算命中率
  _wordComplete(targetWords) {
    let keyWords = []
    for (let i = 0;i < targetWords.length;i++) {
      // 命中
      if (targetWords[i].MatchTag === 0) {
        keyWords.push(targetWords[i].Word)
      }
    }

    return keyWords
  }

  // 上传录音文件
  _upload(blob, name) {
    return new Promise((resolve, reject) => {
      let postData = new FormData()
      postData.append(
        "files",
        new File([blob], `${name}-${Date.now()}.mp3`, {
          type: "audio/mp3",
          lastModified: Date.now(),
        })
      )

      http
        .post({
          url: "/imgup/misc/upload/neverexpire",
          headers: {
            "Content-Type": "multipart/form-data",
            app: process.env.VUE_APP_TYPE,
          },
          data: postData,
        })
        .then((res) => {
          resolve(res.data[0].url)
        })
        .catch((err) => {
          console.log(err)
          reject(null)
        })
    })
  }
}
